import { PutDateReq } from '@gateway.Home'
import { yamadumiApi } from '../yamadumi-api'

/**
 * 日付情報登録
 */
export class PutDateGateway {
  static putDate = async (params: PutDateReq) => {
    return await yamadumiApi.put('/api/common/date', { data: params })
  }
}
